// extracted by mini-css-extract-plugin
module.exports = {"container":"DocumentModale_container__35-Da","file":"DocumentModale_file__2--4M","link":"DocumentModale_link__2L55l","delete":"DocumentModale_delete__lliFq"};